import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import "../../styles/components/navbar.css";

const externalLinks = require("../../data/externalLinks.json");

function Navbar() {
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setHidden(true); // Oculta la navbar si el usuario baja
      } else {
        setHidden(false); // Muestra la navbar si el usuario sube
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <motion.header
        className="navbar"
        initial={{ y: 0 }}
        animate={{ y: hidden ? -100 : 0 }} // Se mueve hacia arriba para ocultarse
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <div className="navbar-content">
          <img
            src="images/logos/BSitesLogo00.webp"
            alt="Logo00"
            draggable={false}
          />
          <nav className="nav-links">
            <ul>
              <li>
                <a href="#hero" title="Ir a sección Inicio">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#about" title="Ir a sección Quiénes somos">
                  Quiénes somos
                </a>
              </li>
              <li>
                <a href="#services" title="Ir a sección Servicios">
                  Servicios
                </a>
              </li>
              <li>
                <a href="#pricing" title="Ir a sección Planes">
                  Planes
                </a>
              </li>
              <li>
                <a href="#faq" title="Ir a sección Preguntas frecuentes">
                  Ayuda
                </a>
              </li>
              <li>
                <button
                  title="Sección para Clientes"
                  onClick={() => navigate("/clientes")}
                >
                  Clientes
                </button>
              </li>
              {/*<li><a href="Portafolio" title="Ver Portafolio">Portafolio</a></li>*/}
            </ul>
          </nav>
        </div>
      </motion.header>
      <button
        onClick={() => window.open(externalLinks.whatsapp)}
        className="btn-contactanos"
        title="Contáctanos por WhatsApp"
      >
        <FaWhatsapp />
      </button>
    </>
  );
}

export default Navbar;
